if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  // Fetch the country/currency list at most once per page and share the result
  // across every selector instance (header, footer, mobile nav, ...).
  function fetchCountryList() {
    if (!window.Eurus.__countryListPromise) {
      window.Eurus.__countryListPromise = fetch(window.Shopify.routes.root + '?section_id=country-selector')
        .then((response) => response.text())
        .then((response) => {
          return new DOMParser()
            .parseFromString(response, 'text/html')
            .getElementById('list-country').innerHTML;
        });
    }
    return window.Eurus.__countryListPromise;
  }

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({
        openCountry: false,
        cachedResults: false,
        fetching: false,
        init() {
          // Only the currency selector owns a `.country-options` container; the
          // locale selector reuses this component but has no list to warm.
          if (!this.$root.querySelector('.country-options')) return;
          // Warm the currency list while the browser is idle so the first click
          // opens the accordion instantly, with no spinner and no layout shift.
          const prefetch = () => this.fetchCountries();
          if ('requestIdleCallback' in window) {
            requestIdleCallback(prefetch, { timeout: 2000 });
          } else {
            setTimeout(prefetch, 1200);
          }
        },
        fetchCountries() {
          if (this.cachedResults || this.fetching) return;
          const optionEL = this.$root.querySelector('.country-options');
          if (!optionEL) return;
          this.fetching = true;
          fetchCountryList()
            .then((content) => {
              optionEL.innerHTML = content;
              this.cachedResults = true;
            })
            .catch(() => {})
            .finally(() => {
              this.fetching = false;
            });
        },
        submit(value, input) {
          this.$el.closest('#localization_form').querySelector('#' + input).value = value;
          this.$el.closest('#localization_form').submit();
        },
        loadCountry() {
          // Open immediately for a responsive feel; content is already cached
          // (or fills in shortly) so the dropdown never appears to hang.
          this.openCountry = true;
          if (!this.cachedResults) this.fetchCountries();
        },
      }));
    });
  });
}
